<template>
    <section>
        <m-table-list ref="tableList" :fetch-list-func="fetchListFunc" :search-form.sync="filters">
            <template v-slot:search-items>
                <m-search-panel @searchBoxChange="changeSearch" :isShowOpenButton="true">
                    <div slot="title">快速筛选</div>
                    <div class="filters">
                        <div class="filter-item">
                            <div class="demonstration">入驻类型</div>
                            <el-select v-model="filters.settledInType" placeholder="请选择">
                                <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </div>
                        <div class="filter-item">
                            <div class="demonstration">合作方式</div>
                            <el-select v-model="filters.cooperationMode" placeholder="请选择">
                                <el-option v-for="item in wayOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </div>
                        <div class="filter-item">
                            <div class="demonstration">提交时间</div>
                            <div class="block">
                                <DateTimePicker :quickSelect="['7d','30d','3m']" :picker-options="pickerOptions1" v-model="time" type="daterange" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd" @picker="timeChange" start-placeholder="开始日期" end-placeholder="结束日期"></DateTimePicker>
                            </div>
                        </div>
                        <el-button round @click="toCreate">新建</el-button>
                        <el-button round @click="search">查询</el-button>
                        <el-button round @click="clearSearch">重置</el-button>
                        <el-button round @click="toExample">例子</el-button>
                        

                    </div>
                </m-search-panel>
            </template>
            <template v-slot:table-columns>

                <el-table-column prop="settledInTypeName" label="入驻类型" width="80" show-overflow-tooltip></el-table-column>
                <el-table-column prop="name" label="名称" width="120"></el-table-column>
                <el-table-column prop="contactName" label="联系人" width="120"></el-table-column>
                <el-table-column prop="contactPhone" label="联系电话" show-overflow-tooltip></el-table-column>
                <el-table-column prop="cooperationModeName" label="合作方式" width="110" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createTime" label="提交时间" width="160"></el-table-column>
                <el-table-column label="跟进状态">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.followUpStatus" active-color="#13ce66" inactive-color="#ff4949" @change="changeStatue(scope.row.id,scope.row.followUpStatus)"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                        <el-button @click="goDetail(scope.row.id,scope.$index)" type="text" size="small">详情</el-button>
                    </template>
                </el-table-column>

            </template>
        </m-table-list>
    </section>
</template>

<script>
import api from "plus/api";
import tableList from 'components/tableList'
export default {
    data() {
        return {
            tableData: [],
            isTableLoading: true,
            isFollow: "",
            filters: {
                page: 1,
                size: 10,
                settledInType: "", //类型
                cooperationMode: "", //合作方式
                time: ""
            },
            time: "",
            total: 0,
            selectType: "全部",
            typeOptions: [
                {
                    label: "全部",
                    value: ""
                },
                {
                    label: "企业",
                    value: 1
                },
                {
                    label: "个人",
                    value: 2
                },
                {
                    label: "KOL",
                    value: 3
                },
                {
                    label: "医美从业者",
                    value: 4
                }
            ],
            wayOptions: [
                {
                    label: "全部",
                    value: ""
                },
                {
                    label: "佣金提成",
                    value: 1
                },
                {
                    label: "免费项目打版",
                    value: 2
                },
                {
                    label: "广告费",
                    value: 4
                },
                {
                    label: "其他",
                    value: 4096
                }
            ],
            pickerOptions1:{
                onPick: (obj) => {
                    this.pickerMinDate = new Date(obj.minDate).getTime();
                },
                disabledDate:(time)=> {
                    if (this.pickerMinDate) {
                        const day1 =  366 * 24 * 3600 * 1000
                        let maxTime = this.pickerMinDate + day1
                        let minTime = this.pickerMinDate - day1
                        return time.getTime() > maxTime || time.getTime()< minTime
                        // || time.getTime() > Date.now()-1 * 24 * 3600 * 1000
                    }else{
                        
                        //return time.getTime() > Date.now()-1 * 24 * 3600 * 1000
                    }
                    
                }
            },
        };
    },
    components: {
        'm-table-list': tableList
    },
    activated() {
        this.getList();
    },
    destroyed() { },
    methods: {
        changeSearch(){

        },
        fetchListFunc() {
            this.getList();
        },
        handleSearchBoxChange(param) {
        },
        toCreate() {
            this.$router.push({
                name: "demo.add"
            });
        },
        toExample() {
            this.$router.push({
                name: "demo.example"
            });
        },
        async getList() {
            this.isTableLoading = false;
            try {
                const result = await api.entry.getList(this.filters);
                this.tableData = result.data.data.items;
                this.total = result.data.data.total;
                this.isTableLoading = true;
            } catch (error) {
                // this.$message.error({
                //     message:'加载失败',
                //     type:'success'
                // });
            }
        },
        handleSizeChange(e) {
            this.filters.size = e;
            this.getList();
        },
        handleCurrentChange(e) {
            this.filters.page = e;
            this.getList();
        },
        timeChange(e) {
            if (!e) {
                this.filters.time = "";
            } else {
                this.filters.time = `${e[0]},${e[1]}`;
            }
        },
        search() {
            this.filters.page = 1;
            this.getList();
        },
        typeChange() { },
        customSort() { },
        clearSearch() {
            this.time = "";
            this.filters = {
                page: 1,
                size: 10,
                settledInType: "", //类型
                cooperationMode: "", //合作方式
                time: ""
            };
            this.getList();
        },
        goDetail(id, index) {
            const p = this.$createElement;
            var arr = [];
            if (this.tableData[index].settledInTypeName)
                arr.push(
                    p(
                        "p",
                        null,
                        `入驻类型：${this.tableData[index].settledInTypeName}`
                    )
                );
            if (this.tableData[index].name)
                arr.push(p("p", null, `名称：${this.tableData[index].name}`));
            if (this.tableData[index].contactName)
                arr.push(
                    p("p", null, `联系人：${this.tableData[index].contactName}`)
                );

            if (this.tableData[index].contactPhone)
                arr.push(
                    p(
                        "p",
                        null,
                        `联系电话：${this.tableData[index].contactPhone}`
                    )
                );
            arr.push(
                p(
                    "p",
                    null,
                    `推广渠道：${this.tableData[index].promotionChannel ||
                    "暂无"}`
                )
            );
            arr.push(
                p(
                    "p",
                    null,
                    `推广体量：${this.tableData[index].promotionOfBodyMass ||
                    "暂无"}`
                )
            );
            if (this.tableData[index].city)
                arr.push(
                    p("p", null, `所在城市：${this.tableData[index].city}`)
                );
            if (this.tableData[index].cooperationModeName)
                arr.push(
                    p(
                        "p",
                        null,
                        `合作方式：${this.tableData[index].cooperationModeName}`
                    )
                );
            if (this.tableData[index].wechatAccount)
                arr.push(
                    p(
                        "p",
                        null,
                        `微信号：${this.tableData[index].wechatAccount}`
                    )
                );
            if (this.tableData[index].workingTrade)
                arr.push(
                    p(
                        "p",
                        null,
                        `目前从事的行业：${this.tableData[index].workingTrade}`
                    )
                );
            if (this.tableData[index].contentUrl)
                arr.push(
                    p(
                        "p",
                        null,
                        `爆款文章/视频链接：${this.tableData[index].contentUrl}`
                    )
                );
            if (this.tableData[index].workingTime)
                arr.push(
                    p(
                        "p",
                        null,
                        `从业时长（年）：${this.tableData[index].workingTime}`
                    )
                );
            if (this.tableData[index].workingPost)
                arr.push(
                    p(
                        "p",
                        null,
                        `从业岗位：${this.tableData[index].workingPost}`
                    )
                );
            // var arr = [
            //     p('p', null, `入驻类型：${this.tableData[index].settledInTypeName}`),
            //     p('p', null, `名称：${this.tableData[index].name}`),
            //     p('p', null, `联系人：${this.tableData[index].contactName || '暂无'}`),
            //     p('p', null, `联系电话：${this.tableData[index].contactPhone}`),
            //     p('p', null, `推广渠道：${this.tableData[index].promotionChannel || '暂无'}`),
            //     p('p', null, `推广体量：${this.tableData[index].promotionOfBodyMass || '暂无'}`),
            //     p('p', null, `合作方式：${this.tableData[index].cooperationModeName || '暂无'}`),
            // ];
            // if (this.tableData[index].wechatAccount) arr.push(p('p', null, `微信号：${this.tableData[index].wechatAccount}`));
            // if (this.tableData[index].city) arr.push(p('p', null, `所在城市：${this.tableData[index].city}`));
            // if (this.tableData[index].workingTime) arr.push(p('p', null, `从业时长：${this.tableData[index].workingTime}`));
            // if (this.tableData[index].workingPost) arr.push(p('p', null, `从业时长：${this.tableData[index].workingPost}`));
            // if (this.tableData[index].workingTrade) arr.push(p('p', null, `目前从事的行业：${this.tableData[index].workingTrade}`));
            // if (this.tableData[index].contentUrl) arr.push(p('p', null, `爆款文章/视频连接${this.tableData[index].contentUrl}`));
            this.$msgbox({
                title: "详情",
                message: p("p", null, arr)
            });
        },
        async changeStatue(id, stauts) {
            try {
                let res = await api.entry.changeStatus({
                    id: id,
                    hasFollowedUp: stauts
                });
                if (res.data.success) {
                    this.getList();
                    this.$message({
                        message: "修改成功！",
                        type: "success"
                    });
                } else {
                    this.$message.error({
                        message: "修改失败！"
                    });
                }
            } catch (error) {
                this.$message.error(error.msg);
            }
        }
    }
};
</script>
